import { getAuth, isNullOrEmpty, clearCookies, getTokenLoyalty, clearStorage } from 'functions';
import axios from 'axios';
import { httpStatus } from 'model/constants/variableConstant';
import { saveLog } from './LoyaltyGiftService';
import { LINK_DEV } from 'constants/index';
import { rqGetTokenLoyalty } from './LoginService';

const instance = axios.create({
  // baseURL: !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? urlWsEpos : '', // process.env.REACT_APP_BASE_URL : '',
  baseURL: process.env.REACT_APP_API_SERVER_WS,
  timeout: 600000,
});

const instanceLoyalty = axios.create({
  // baseURL: !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? urlWsEpos : '', // process.env.REACT_APP_BASE_URL : '',
  baseURL: process.env.REACT_APP_API_LOYALTY,
  timeout: 600000,
});

export function request(req) {
  const auth = getAuth();
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: !isNullOrEmpty(auth) ? auth.token : null,
    },
    data: req,
  };
}

export function response(url, req) {
  return instance({
    url: url,
    ...req,
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      if (error.response && error.response.status === httpStatus.unauthorized) {
        clearCookies();
        // window.location.href = LINK_DEV;
        // window.location.href = `${LINK_DEV}/?logout`;
      } else {
        // window.location.href ='/pages/error-page';
      }
      throw error;
    });
}

export function requestGetMethod(req, options) {
  const auth = getAuth();
  return {
    // credentials: 'same-origin',
    method: 'GET',
    headers: {
      // 'Accept': 'application/json',
      'Content-Type': 'application/json',
      Authorization: !isNullOrEmpty(auth) ? auth.token : null,
    },
    data: req,
    ...options,
  };
}

export function requestPostUrl() {
  const auth = getAuth();
  return {
    // credentials: 'same-origin',
    method: 'POST',
    headers: {
      // 'Accept': 'application/json',
      'Content-Type': 'application/json',
      Authorization: !isNullOrEmpty(auth) ? auth.token : null,
    },
  };
}

export function requestGET() {
  const auth = getAuth();
  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: !isNullOrEmpty(auth) ? auth.token : null,
    },
  };
}
export function requestJson(reqJson) {
  const auth = getAuth();
  return {
    // credentials: 'same-origin',
    method: 'POST',
    headers: {
      // 'Accept': 'application/json',
      'Content-Type': 'application/json',
      Authorization: !isNullOrEmpty(auth) ? auth.token : null,
    },
    // data: JSON.stringify(reqJson)
    data: reqJson,
  };
}

export function requestLogin(reqJson) {
  return {
    // credentials: 'same-origin',
    method: 'POST',
    headers: {
      // 'Accept': 'application/json',
      'Content-Type': 'application/json',
      AppCode: appCodes.EPOS,
    },
    data: JSON.stringify(reqJson),
  };
}

export function requestLoyaltyWS(method, params, body) {
  const auth = getAuth();
  return {
    method: method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: !isNullOrEmpty(auth) ? auth.token : null,
    },
    data: body,
    params: params,
  };
}

export function responseLoyaltyWS(url, req) {
  const auth = getAuth();
  return instanceLoyalty({
    url: url,
    ...req,
  })
    .then(function (response) {
      // saveLog({
      //   requestUrl: response.config?.url,
      //   requestBody: JSON.stringify(response.config?.params),
      //   responseBody: JSON.stringify(response.data),
      //   responseCode: response.status.toString(),
      //   userRequest: auth.userCode
      // })
      return response.data;
    })
    .catch(function (error) {
      if (error.response && error.response.status === httpStatus.unauthorized) {
        clearCookies();
        // window.location.href = LINK_DEV;
        // window.location.href = `${LINK_DEV}/?logout`;
      } else {
        // window.location.href ='/pages/error-page';
      }
      throw error;
    });
}
